import { gql, QueryHookOptions, useQuery } from '@apollo/client';

export const useQueryImportLog = (
  options?: QueryHookOptions<ImportLogData, ImportLogVariables>,
) => useQuery<ImportLogData, ImportLogVariables>(IMPORT_LOG, options);

export const IMPORT_LOG = gql`
  query importLog($id: String!) {
    importLog(id: $id) {
      importer
      parsedCount
      importedCount
      errorItemsCount
      createdAt
      errorItems {
        indexName
        errors
      }
    }
  }
`;

export type ImportLogVariables = {
  id: string;
};

export type ImportLogData = {
  importLog: ImportLogDetail;
};

export type ImportLogDetail = {
  importer: string;
  parsedCount: number;
  importedCount: number;
  errorItemsCount: number;
  createdAt: string;
  errorItems: ImportLogErrorItem[];
};

export type ImportLogErrorItem = {
  indexName: string;
  errors: string;
};
